// Highlighting for code blocks
import "prismjs/themes/prism.css"
